import axios from 'axios'
const baseUrl = '/api/'


const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': 'http://localhost:3001/'
}

const getTops = (gen) => {
   
    const req =  axios.get(`${baseUrl}tops`, {
        params: {
            gender : gen
        }
    })
    return req.then(res => res.data)
}

const getTrousers = (gen) => {
    const req = axios.get(`${baseUrl}trousers`, {
        params: {
            gender : gen
        }
    })
    return req.then(res => res.data)
}

const getShoes = (gen) => {
    const req = axios.get(`${baseUrl}footwear`, {
        params : {
            gender : gen
        }
    })
    return req.then(res => res.data)
}



const generateOutfits = async (item, wardrobe, scheme) => {
    //console.log("THE WARDROBE", wardrobe)
    const wardrobeAndItemObj = {
        selectedItem : item,
        selectedWardrobe : wardrobe,
        selectedScheme : scheme,
    };

    const jsonObj = JSON.stringify(wardrobeAndItemObj)
    const res = await axios.post(`${baseUrl}generateoutfits`, jsonObj,
    {
        headers : headers
    }
    
    )
    
    if( res.status==201){
        console.log("Success")
    }
    return res.data
}

export default {
    getTops : getTops,
    getTrousers : getTrousers,
    getShoes : getShoes,
    generateOutfits : generateOutfits
}
